module.exports = __webpack_public_path__ + "img/slide-liga-help.fb61eb76.png";